import React, { useState, useEffect } from 'react'
import {
  toaster,
  Table,
  Text,
  Pane,
  SideSheet,
  Alert,
  Heading,
  Paragraph,
  Spinner,
  Card,
  Pagination,
  Button,
  LinkIcon,
  ShoppingCartIcon,
  Dialog,
  majorScale,
  TextInputField,
  SelectField,
} from 'evergreen-ui'

import { useAPI } from '../Api';
import { ErrorBoundary } from '../Misc';
import { json } from 'react-router-dom';
import { OrderRow } from './OrderRow'
import { Money } from '../Misc';
import { useCart } from '../Cart';
import { BookOrder } from '../Cart';
import { findMaterial } from '../Quote/Materials/MaterialFuncs';
import { Routes, Route, Link, useNavigate, Navigate } from "react-router-dom";
import { set } from 'react-hook-form';
import { CONSOLE_LEVELS } from '@sentry/utils';


let moneyformatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
})
let isMoney = (v) => Number.isInteger(Math.round(parseFloat(v) * 100))

function WebStockDetailsLnk(props) {
  let containerProps = props.containerProps ?? []
  return (
    <Button
      iconBefore={LinkIcon}
      intent="success"
      onClick={() => {
        window.open('/products/?md=' + props.webStock.Id, '_blank')
      }}
      {...containerProps}
    >
      {props.children ? props.children : 'View'}
    </Button>
  )
}

function WebStockCard(props) {
  const { webStock } = props
  const description = webStock.Description //.replace(/\n/g, <br />)

  return (
    <Pane
      elevation={1}
      alignItems="center"
      display="flex"
      flex="1"
      flexDirection="row"
      padding={16}
    >
      <img style={{ maxWidth: '30%' }} flex="1" src={webStock.imgurlLarge} />
      <Paragraph flex="1" paddingLeft={16}>
        {description}
        <WebStockDetailsLnk
          containerProps={{
            marginTop: 16,
          }}
          {...props}
        >
          View more details...
        </WebStockDetailsLnk>
      </Paragraph>
    </Pane>
  )
}

function WebStockOption(props) {
  const { option } = props
  const [value, setValue] = React.useState('foo')

  useEffect(() => {
    ; (async () => {
      setValue(option.Selected)
      props.onChange(props.WSID, option.Options[option.Selected].BasePrice, option.Selected)
    })()
  }, [])

  return (
    <SelectField
      label={option.Name}
      value={value}
      onChange={(e) => {
        props.onChange(
          props.WSID,
          parseInt(e.target.value) <= 0
            ? 0
            : option.Options[e.target.value].BasePrice ?? 0,
          e.target.value,
        )
        setValue(e.target.value)
      }}
    >
      {' '}
      <option key="No" value={0}>
        Not selected
      </option>
      {Object.keys(option.Options).map((o, index) => (
        <option key={option.Options[o].Id} value={option.Options[o].Id}>
          {option.Options[o].Title}
        </option>
      ))}
    </SelectField>
  )
}

function WebStockOptions(props) {
  const { Options, onChange, onOptionsChange } = props

  const [totals, setTotals] = React.useState({})
  const [options, setOptions] = React.useState({})

  const updateTotal = (o, v, id) => {
    totals[o] = v
    options[o] = id
    setTotals(totals)
    setOptions(options)
    //if any values == null then price is TBA
    let left = Object.keys(totals).filter((v) => !totals[v])
    let optlist = Object.keys(options)
      .filter((v) => options[v])
      .map((v) => options[v])

    onOptionsChange(optlist)
    onChange(
      left.length > 0
        ? null
        : Object.keys(totals).reduce((t, v) => (t += parseFloat(totals[v])), 0),
    )
  }

  return (
    <Pane>
      {Object.keys(Options).map((o, index) => (
        <WebStockOption
          key={o}
          WSID={o}
          option={Options[o]}
          onChange={updateTotal}
        ></WebStockOption>
      ))}
    </Pane>
  )
}

function WebStockDlg(props) {
  const [isShown, setIsShown] = React.useState(false)
  const [qty, setQty] = React.useState(props.Qty || 1)
  const [total, setTotal] = React.useState(0)
  const [optTotal, setOptTotal] = React.useState(0)
  const [options, setOptions] = React.useState([])
  const { webStock } = props
  const BasePrice = parseFloat(webStock.prices.BasePrice)

  useEffect(() => {
    ; (async () => {
      if (qty <= 0) setQty(1)
      setTotal(optTotal == null ? 'TBA' : qty * (BasePrice + optTotal))
    })()
  }, [qty, optTotal])

  return (
    <Pane key={webStock.Id} marginRight={majorScale(2)}>
      <Dialog
        isShown={isShown}
        title={webStock.Title}
        onCloseComplete={() => setIsShown(false)}
        confirmLabel="Add to Cart"
        cancelLabel="Close"
        onConfirm={(close) => {
          var postvar = {}
          postvar.laster = '0'
          postvar.qty = qty
          postvar['id'] = webStock.Id
          postvar['action'] = 'pc_addtocart'
          postvar['um_request'] = ''
          postvar['pcaction'] = 'Add to cart'

          let formBody = new URLSearchParams(postvar)
          options.forEach((o) => {
            formBody.append('options[]', o)
          })



          //   const formBody = Object.keys(postvar).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(postvar[key])).join('&');
          toaster.warning('Adding to cart....', {
            id: 'cart-action'
          })
          close()

          fetch('/products/?md=' + webStock.Id, {
            headers: {
              'content-type': 'application/x-www-form-urlencoded',
            },
            body: formBody.toString(),
            //  'base=&laser=0&options%5B%5D=24&qty=1&total=%249.00&id=81&action=pc_addtocart&um_request=&pcaction=Add+to+cart',
            method: 'POST',
          }).then((f) => {
            toaster.success('Added to cart', {
              id: 'cart-action'
            })

          })
        }}
      >
        <Pane display="flex" flexDirection="column">
          <WebStockCard {...props} />
          <Pane
            elevation={1}
            display="flex"
            flex="1"
            flexDirection="row"
            padding={16}
          >
            {' '}
            <Pane flex="1" padding={16} marginTop={16}>
              <WebStockOptions
                Options={webStock.Options}
                onChange={setOptTotal}
                onOptionsChange={setOptions}
              />
              {webStock.Canlaser != 0 && <h1>Canlaser</h1>}
              {webStock.Canpowder != 0 && <h1>Canpowder</h1>}
            </Pane>
            <Pane flex="1" padding={16} marginTop={16}>
              <TextInputField
                label="Qty"
                type="number"
                onChange={(e) => setQty(e.target.value)}
                value={qty}
                required
              />
              <TextInputField
                label="Total"
                value={!isMoney(total) ? 'TBA' : moneyformatter.format(total)}
                readOnly
              />
              <i>Prices are Ex GST</i>
            </Pane>
          </Pane>
        </Pane>
      </Dialog>

      <Button iconBefore={ShoppingCartIcon} onClick={() => setIsShown(true)}>
        Add to Cart
      </Button>
    </Pane>
  )
}

function CartButton(props) {
  return (
    <Pane display="flex" alignItems="center">
      <WebStockDlg {...props} />
      <WebStockDetailsLnk {...props} />
    </Pane>
  )
}

function OrderRows(props) {
  // console.log("In OrderRows", props)

  let API = useAPI()
  const [data, setData] = React.useState([]);
  const [details, setDetails] = React.useState([]);
  const [busy, setBusy] = React.useState(false);
  const [items, setItems] = React.useState([]);

  const selectedItems = (i, bool) => {
    //true = item was selected, False = Item was unselected
    bool ? setItems([...items, i]) : setItems(items.filter((v) => v[0].Transno != i[0].Transno));
  }

  useEffect(() => {
    props.getSelectedItems(items);
  }, [items])


  const fetchOrders = async () => {
    setBusy(true)
    setData([])
    setDetails([])

    return API.jsonFetch('orders/' + props.Hash + '/details').then((res) => {
      if (res.data && res.data) {
        setData(Object.values(res.data.rows));
        setDetails(res.data.details);
      }
      setBusy(false)
    })
  }

  useEffect(() => {
    //Pair each item with the order data from DB and details.json from S3 Bucket if any
    const combinedArray = data.map((element, index) => [element, details ? details[index] : null]);
    props.getAllItems(combinedArray);
  }, [details])

  useEffect(() => {
    fetchOrders()
  }, [])


  let error = null;
  // const [data, isLoading, error] = useFetch('orders/' + props.Hash, props.Ajax)
  return (
    <Card backgroundColor="white" elevation={0} height={"100%"} display="flex" width={"100%"} flexWrap={"wrap"} justifyContent="center" alignItems="center">

      {busy &&
        <Pane display="flex" alignItems="center" justifyContent="center" height={200}>
          <Spinner />
        </Pane>
      }

      {error && <Alert intent="warning" title={error} />}
      {data && data.error && <Alert intent="warning" title={data.error} />}

      {data && data.map((order, i) => {
        if (order.Description.includes(details && details[i] ? details[i].book.display : "")) {
          return <OrderRow key={i} order={order} details={details && details[i] ? details[i] : null} selectedItems={selectedItems} />
        }
        // if (details && details[i]) {
        //   return <><h1>TRUE</h1></>
        // }
      })}
      {/* {!details && <Pane display="flex" justifyContent="center" alignItems="center" border="2px dashed" borderRadius={"10px"} padding={50} margin={20}><Text size={600}>Please contact durador to get the details of this order</Text></Pane>} */}
    </Card>
  )
}

function OrderDialog(props) {
  const [items, setItems] = React.useState([]);
  const [allItems, setAllItems] = React.useState([]);
  const [itemCount, setItemCount] = React.useState(0);
  const [alert, setAlert] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const CANT_ORDER_MSG = "Please contact Durador to reorder this specific order"
  const API = useAPI();
  const Cart = useCart();
  let navigate = useNavigate();

  const getSelectedItems = (i) => {
    setItems(i);
    setItemCount(i.length);
  }

  const getAllItems = (i) => {
    setAllItems(i);
  }

  const handleOrder = (orders) => {
    if (alert) {
      toaster.danger(CANT_ORDER_MSG);
      setBusy(false);
      return;
    }
    addToCart(orders)
  }

  useEffect(() => {
    if (allItems.length > 0) {
      let res = false; 
      let f = allItems[0];
      //case if no aws details are found
      if(!f[1]){
        res = true;
      }
      //case if aws details are found but the file does not match
      if(f[1]){
        f[0].Description.includes(f[1].book.display) ? res = false : res = true;
      }
      setAlert(res);
    }
  }, [allItems]);

  const addToCart = async (orders) => {

    let items = orders.map((o) => {
      o = o[1];
      let reOrder = new BookOrder(o.book);
      reOrder.bends = o.bends;
      reOrder.color = o.color;
      reOrder.cuts = o.cuts;
      reOrder.selMaterial = o.selMaterial;
      reOrder.qty = o.qty;
      reOrder.cuttingLength = o.cuttingLength;
      return reOrder;
    })

    for (let index = 0; index < items.length; index++) {
      const o = items[index];
      try {
        let a = API.getMaterial(o)
        const m = await a
        o.selMaterial = findMaterial(m.Materials, o.selMaterial);
        o.RawSetupFee = m.SetupFee;
      } catch (error) {
        console.error(`Error fetching material for order ${index}: ${error}`);
        toaster.danger("An Error has occurred, if this persists please contact Durador");
        setBusy(false);
      }
    }

    Cart.add(items);
    setBusy(false);
    toaster.success("Added " + items.length + (items.length > 1 ? " items" : " item") + " to the cart");
    navigate('/cart');
  }

  return (
    <Pane>
      <Dialog
        isShown={props.isShown}
        title={props.orderDetails.InvNo}
        onCloseComplete={() => props.setIsShown(false)}
        shouldCloseOnOverlayClick={false}
        width={"100%"}
        minHeightContent={"100%"}
        hasFooter={false}
      >
        {busy ? <Pane display="flex" alignItems="center" justifyContent="center" height={400} flexDirection="column">
          <Spinner />
          <Text size={600}><strong>Adding items to cart...</strong></Text>
        </Pane> : <>
          {alert &&
            <Alert intent="danger" title="Contact Durador">
              {CANT_ORDER_MSG}
            </Alert>
          }
          <Pane width={"100%"} display="flex" justifyContent="center" alignItems="flex" position="sticky" top="0" zIndex={"100"}>
            <Pane display={"flex"} height={"75px"} width={"90%"} justifyContent="right" padding={"10px"} gap={"10px"}>
              {itemCount > 0 && <Button appearance='primary' onClick={() => {setBusy(true); handleOrder(items); }}>Add {itemCount} selected item{itemCount > 1 && "s"} to  cart</Button>}
              <Button appearance='primary' onClick={() => { setBusy(true); handleOrder(allItems);}}>Add all items to cart</Button>
            </Pane>
          </Pane>
          {props.orderDetails && (
            <OrderRows Hash={props.orderDetails.Hash} Ajax={props.Ajax} getSelectedItems={getSelectedItems} getAllItems={getAllItems} />
          )}
        </>
        }
      </Dialog>
    </Pane>
  )

}

let PagesOrdersRows = (props) => {
  const [page, setPage] = React.useState(1)
  let rowPerPage = 10

  let onNextPage = () => {
    setPage(page + 1)
  }

  let onPreviousPage = () => {
    setPage(page - 1)
  }

  let rows = props.orders.length
  let pageCount = Math.ceil(rows / rowPerPage)
  let itemOffset = rowPerPage > rows ? 0 : ((page - 1) * rowPerPage) % rows

  return (

    <Pane height={"100%"}>
      {/* <pre>{JSON.stringify(props.orders[1])}</pre> */}
      <Table elevation={3}>
        <Table.Head>
          <Table.TextHeaderCell>InvNo#</Table.TextHeaderCell>
          <Table.TextHeaderCell>PO#</Table.TextHeaderCell>
          <Table.TextHeaderCell>Order Total</Table.TextHeaderCell>
          <Table.TextHeaderCell>Status</Table.TextHeaderCell>
          <Table.TextHeaderCell>Tracking#</Table.TextHeaderCell>
          <Table.TextHeaderCell>Dispatch Date</Table.TextHeaderCell>
          <Table.TextHeaderCell>Received</Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody height={500}>
          {props.orders
            .slice(itemOffset, itemOffset + rowPerPage)
            .map((order, i) => (
              <Table.Row key={i + itemOffset}  >
                <Table.TextCell><Button appearance='primary' onClick={() => { props.showDlg(order) }}>{order.InvNo}</Button></Table.TextCell>
                <Table.TextCell>{order.Customerpo}</Table.TextCell>
                <Table.TextCell> {order.TotalInvoiceValue ? <Money>{order.TotalInvoiceValue}</Money> : "N/A"}</Table.TextCell>
                <Table.TextCell>{order.Status}</Table.TextCell>
                <Table.TextCell>{order.TrackingNumber}</Table.TextCell>
                <Table.TextCell>{order.DispatchDate}</Table.TextCell>
                <Table.TextCell>{order.Saleentrydate ?

                  <ErrorBoundary>
                    {
                      new Intl.DateTimeFormat('en-AU', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                      }).format(new Date(order.Saleentrydate))
                    }</ErrorBoundary>

                  : 'No Date'}</Table.TextCell>
              </Table.Row>
            ))}
        </Table.VirtualBody>
      </Table>
      {pageCount > 1 ? (
        <Pagination
          totalPages={pageCount}
          page={page}
          onPageChange={setPage}
          onNextPage={onNextPage}
          onPreviousPage={onPreviousPage}
        ></Pagination>
      ) : (
        ''
      )}
    </Pane>
  )
}

export let Orders = (props) => {
  const [orders, setOrders] = useState()
  const [orderDetails, setOrderDetails] = useState(false)
  const [isShown, setIsShown] = React.useState(false)
  const [busy, setBusy] = React.useState(false)

  let API = useAPI()

  const fetchOrders = async () => {
    setBusy(true);
    setOrders([])
    return API.jsonFetch('orders/current').then((res) => {
      if (res.data && res.data.orders) {
        let orders = res.data.orders.sort(function (a, b) {
          if (!a.Saleentrydate) return 1
          if (!b.Saleentrydate) return -1
          return new Date(b.Saleentrydate) - new Date(a.Saleentrydate)
        })
        setOrders(orders)
      }
      setBusy(false);
    })
  }

  useEffect(() => {
    fetchOrders()
  }, [])

  let showDlg = (Hash) => {
    // console.log('showdlg', Hash)
    setIsShown(false)
    if (Hash) {
      setOrderDetails(Hash)
      setIsShown(true)
    }
  }

  return (
    <Pane textAlign={"center"} padding={8} margin={'auto'} width={'100%'} height={"100%"} elevation={2} background='white'>
      {orders && orders.error && (
        <Alert intent="warning" title={orders.error} />
      )}
      {orderDetails && (
        <OrderDialog
          key={orderDetails.Hash}
          isShown={isShown}
          setIsShown={setIsShown.bind(this)}
          orderDetails={orderDetails}
          {...props}
        ></OrderDialog>
      )}
      {busy ? <Pane display="flex" alignItems="center" flexDirection={"column"} justifyContent="center" height={400}> <Spinner /> <Text size={600}><strong>Loading Orders...</strong></Text> </Pane> : 
      <PagesOrdersRows
        orders={orders && !orders.error ? orders : []}
        showDlg={showDlg.bind(this)}
      />
      }
    </Pane>
  )
}
